// AI Generated Component
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ToastService } from '@monsido/angular-shared-components';
import { UptimeRepoService } from '@client/app/services/api/uptime-repo/uptime-repo.service';
import { FormUptimeService } from '@client/app/forms/uptime/uptime-service/uptime.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'uptime',
    standalone: false,
    template: `
        <form #uptimeForm="ngForm" class="form-horizontal" (ngSubmit)="!saving && uptimeForm.valid && submit()">
            <div class="mon-dialog-header">
                <div class="row">
                    <div class="col-48 outer-t-smurf">
                        <page-header header="{{'Uptime Monitoring' | translate }}"
                                     panelClass="row"
                                     panelLeftClass="col-48 mt-1">
                        </page-header>
                    </div>
                </div>
            </div>

            <div class="mon-dialog-body-with-footer bg-body">
                <div class="card panel-monsido-card mt-4 mx-4">
                    <mon-panel-header pHeader="{{ 'Checkpoint information' | translate }}"></mon-panel-header>
                    <div class="card-body">
                        <div class="form-group row mb-6">
                            <label for="status" class="col-sm-8 col-form-label text-bold text-right" translate>
                                Status
                            </label>
                            <div class="col-sm-40">
                                <form-field-material-switch name="status"
                                                            class="block"
                                                            [(ngModel)]="ngModel.status">
                                </form-field-material-switch>
                                <span class="form-text text-muted" translate>Should we check the page's current status?</span>
                            </div>
                        </div>

                        <form-field-input name="url"
                                          [ngRequired]="true"
                                          [required]="true"
                                          httpPrefix="true"
                                          [(ngModel)]="ngModel.url"
                                          label="{{ 'URL' | translate }}"
                                          placeholder="{{ 'URL' | translate }}"
                                          type="text"
                                          helpTxt="{{ 'Enter the full URL' | translate }} {{'(eg. http://www.mydomain.com)'}}"
                                          class="mb-6 block">
                        </form-field-input>

                        <form-field-select *ngIf="pingIntervals.length > 0"
                                           label="{{'Ping intervals' | translate}}"
                                           name="pingtime"
                                           [(ngModel)]="ngModel.pingtime"
                                           [options]="pingIntervals"
                                           nameAttr="name"
                                           (ngChange)="addOneMinuteOptionIfThePingTimeIsOneMinute()"
                                           returnValue="value"
                                           [ngRequired]="true"
                                           [required]="true"
                                           class="mb-3 block">
                        </form-field-select>

                        <div class="form-group row">
                            <label for="notification_long" class="col-sm-8 col-form-label text-bold text-right" translate>
                                Response time notification
                            </label>
                            <div class="col-sm-40">
                                <form-field-material-switch name="notification_long"
                                                            class="block"
                                                            [(ngModel)]="ngModel.notification_long">
                                </form-field-material-switch>
                                <p class="help-block" translate>Send an email if the site is slow to respond</p>
                            </div>

                        </div>

                        <div class="px-6 well" *ngIf="ngModel.notification_long">
                            <div class="mb-3">
                                <form-field-select [(ngModel)]="ngModel.answertime"
                                                   name="answertime"
                                                   [ngRequired]="true"
                                                   [options]="uptimeAnswerTimeOptions"
                                                   label="{{ 'Response time' | translate }}"
                                                   returnValue="value"
                                                   defaultOption="{{ 'Choose a response time' | translate }}"
                                                   helpTxt="{{'Response time notification threshold' | translate}}">
                                </form-field-select>
                            </div>

                            <div class="mb-3">
                                <form-field-select [(ngModel)]="ngModel.answertime_requests"
                                                   name="answertime_requests"
                                                   [ngRequired]="true"
                                                   [options]="uptimeAnswerTimeRequestOptions"
                                                   label="{{ 'Response time notification' | translate }}"
                                                   returnValue="value"
                                                   defaultOption="{{ 'Choose a response time notification' | translate }}"
                                                   helpTxt="{{'Minutes of slow response before you get an email' | translate}}">
                                </form-field-select>
                            </div>

                            <div class="form-group row uptime-email-selector-container">
                                <label for="email_long_receivers" class="col-sm-8 col-form-label text-bold text-right" translate>
                                    Email receiver *
                                </label>
                                <div class="col-sm-40">
                                    <email-tags-input name="email_long_receivers"
                                                [(ngModel)]="notiFails"
                                                placeholder="{{'Add email' | translate}}"
                                                class="uptime-email-selector"
                                                required>
                                    </email-tags-input>
                                </div>
                            </div>
                            <form-field-errors [input]="uptimeForm.controls['email_long_receivers']" class="mb-3">
                            </form-field-errors>
                        </div>

                        <div class="form-group row">
                            <label for="notification_fail" class="col-sm-8 col-form-label text-bold text-right" translate>
                                Downtime notification
                            </label>
                            <div class="col-sm-40">
                                <form-field-material-switch name="notification_fail"
                                                            class="block"
                                                            [(ngModel)]="ngModel.notification_fail">
                                </form-field-material-switch>
                                <p class="form-text text-muted" translate>Send an email if the site is down</p>
                            </div>
                        </div>

                        <div class="pl-6 well" *ngIf="ngModel.notification_fail">
                            <div class="form-group row">
                                <label for="pingtime_requests"
                                       ngbTooltip="{{'This is the time between when an outage is first detected and when a notification is sent.' | translate}}"
                                       [triggers]="'focus hover'"
                                       class="col-sm-8 col-form-label text-bold text-right"
                                       translate>
                                    Time to Warning *
                                </label>
                                <div class="col-sm-40">
                                    <angular-selector
                                            monId="pingtime_requests"
                                            [removeButton]="false"
                                            labelAttr="name"
                                            valueAttr="value"
                                            placeholder="{{'Choose notification time' | translate}}"
                                            [options]="uptimePingTimeRequestOptions"
                                            [(ngModel)]="ngModel.pingtime_requests"
                                            name="pingtime_requests"
                                            [required]="true">
                                    </angular-selector>
                                </div>
                            </div>
                            <div class="form-group uptime-email-selector-container row">
                                <label for="email_fails_receiver" class="col-sm-8 col-form-label text-bold text-right" translate>
                                    Email receiver *
                                </label>
                                <div class="col-sm-40">
                                    <email-tags-input name="email_fails_receiver"
                                                [(ngModel)]="emailFails"
                                                placeholder="{{'Add email' | translate}}"
                                                class="uptime-email-selector"
                                                required>
                                    </email-tags-input>
                                </div>
                            </div>
                            <div class="form-group uptime-email-selector-container row">
                                <label for="notification_fail_end" class="col-sm-8 col-form-label text-bold text-right" translate>
                                    Notification when the downtime ends
                                </label>
                                <div class="col-sm-40 pl-1">
                                    <form-field-material-switch name="notification_fail_end" class="block"
                                        [(ngModel)]="ngModel.notification_fail_end">
                                    </form-field-material-switch>
                                </div>
                            </div>
                            <form-field-errors [input]="uptimeForm.controls['email_fails_receiver']" class="mb-3">
                            </form-field-errors>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mon-dialog-footer text-right">
                <button class="btn btn-border-radius btn-secondary"
                        [disabled]="saving || uptimeForm.invalid"
                        monEventTrigger="actionTrigger"
                        [monEventParams]="{action: 'heartbeat-form-save'}"
                        type="submit">
                    <span [hidden]="saving">Save</span>
                    <span [ngClass]="{'fas fa-spinner fa-spin fa-lg': saving}"></span>
                </button>
            </div>
        </form>
    `,
})
export class UptimeComponent implements OnInit {
    @ViewChild('uptimeForm') uptimeForm!: NgForm;
    @Input() uptime: any;
    @Input() monDialogId?: string;
    @Input() setForm?: any;

    ngModel: any = {};
    emailFails: any[] = [];
    notiFails: any[] = [];
    saving: boolean = false;
    pingIntervals: any[] = [];
    uptimeAnswerTimeOptions: any[] = [];
    uptimeAnswerTimeRequestOptions: any[] = [];
    uptimePingTimeRequestOptions: any[] = [];

    constructor (
        private monDialog: MonDialog,
        private translateService: TranslateService,
        private toastService: ToastService,
        private uptimeRepoService: UptimeRepoService,
        private formUptimeService: FormUptimeService,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.ngModel = safeClone(this.uptime) || { pingtime_requests: 5, answertime_requests: 3000 };
        this.emailFails = [];
        this.notiFails = [];
        this.saving = false;
        this.pingIntervals = this.formUptimeService.getIntervalOptions();
        this.setupAnswerTimeRequests();
        this.setupPingTimeRequests();
        this.setupAnswerTime();
        this.addOneMinuteOptionIfThePingTimeIsOneMinute();

        if (typeof this.ngModel.email_fail === 'string') {
            this.emailFails = this.ngModel.email_fail.split(',').filter(Boolean);
        }

        if (typeof this.ngModel.email_long === 'string') {
            this.notiFails = this.ngModel.email_long.split(',').filter(Boolean);
        }

        setTimeout(() => {
            if (this.setForm) {
                this.setForm({ id: this.monDialogId, form: this.uptimeForm });
            }
        });
    }

    setupAnswerTime (): void {
        this.uptimeAnswerTimeOptions = [
            {
                name: this.translateService.getString('Over 200 ms.'),
                value: 200,
            },
            {
                name: this.translateService.getString('Over 500 ms.'),
                value: 500,
            },
            {
                name: this.translateService.getString('Over 1000 ms.'),
                value: 1000,
            },
            {
                name: this.translateService.getString('Over 2000 ms.'),
                value: 2000,
            },
            {
                name: this.translateService.getString('Over 3000 ms.'),
                value: 3000,
            },
            {
                name: this.translateService.getString('Over 4000 ms.'),
                value: 4000,
            },
            {
                name: this.translateService.getString('Over 5000 ms.'),
                value: 5000,
            },
            {
                name: this.translateService.getString('Over 6000 ms.'),
                value: 6000,
            },
            {
                name: this.translateService.getString('Over 7000 ms.'),
                value: 7000,
            },
            {
                name: this.translateService.getString('Over 8000 ms.'),
                value: 8000,
            },
            {
                name: this.translateService.getString('Over 9000 ms.'),
                value: 9000,
            },
            {
                name: this.translateService.getString('Over 10000 ms.'),
                value: 10000,
            },
        ];
        if (typeof this.ngModel.answertime === 'undefined') {
            this.ngModel.answertime = this.uptimeAnswerTimeOptions[0].value;
        }
    }

    setupAnswerTimeRequests (): void {
        this.uptimeAnswerTimeRequestOptions = [
            {
                name: this.translateService.getString('5 min.'),
                value: 5,
            },
            {
                name: this.translateService.getString('10 min.'),
                value: 10,
            },
            {
                name: this.translateService.getString('15 min.'),
                value: 15,
            },
            {
                name: this.translateService.getString('30 min.'),
                value: 30,
            },
        ];
        if (typeof this.ngModel.answertime_requests === 'undefined') {
            this.ngModel.answertime_requests = this.uptimeAnswerTimeRequestOptions[0].value;
        }
    }

    setupPingTimeRequests (): void {
        this.uptimePingTimeRequestOptions = [
            {
                name: this.translateService.getString('5 min.'),
                value: 5,
            },
            {
                name: this.translateService.getString('10 min.'),
                value: 10,
            },
            {
                name: this.translateService.getString('15 min.'),
                value: 15,
            },
            {
                name: this.translateService.getString('30 min.'),
                value: 30,
            },
            {
                name: this.translateService.getString('60 min.'),
                value: 60,
            },
            {
                name: this.translateService.getString('120 min.'),
                value: 120,
            },
        ];
        if (typeof this.ngModel.pingtime_requests === 'undefined') {
            this.ngModel.pingtime_requests = this.uptimePingTimeRequestOptions[0].value;
        }
    }

    close (uptime: any): void {
        this.monDialog.close(this.monDialogId, uptime);
    }

    submit (): void {
        let promise: any;
        this.saving = true;

        if (this.ngModel.notification_fail) {
            this.ngModel.email_fail = this.emailFails
                .join(',');
        }
        if (this.ngModel.notification_long) {
            this.ngModel.email_long = this.notiFails
                .join(',');
        }

        if (this.ngModel.id) {
            promise = this.uptimeRepoService.update(this.ngModel);
        } else {
            promise = this.uptimeRepoService.create(this.ngModel);
        }

        promise
            .then((uptime: any) => {
                this.toastService.success(this.translateService.getString('Uptime Monitoring status saved'));
                if (this.uptimeForm) {
                    this.uptimeForm.resetForm();
                }
                this.close(uptime);
            }, () => {})
            .finally(() => {
                this.saving = false;
            });
    }

    addOneMinuteOptionIfThePingTimeIsOneMinute (): void {
        if (this.ngModel.pingtime === 60) {
            if (this.pingIntervals[0]) {
                if (
                    this.pingIntervals[0].value === 60 &&
                    this.uptimeAnswerTimeRequestOptions[0].value !== 1 &&
                    this.uptimePingTimeRequestOptions[0].value !== 1
                ) {
                    this.uptimeAnswerTimeRequestOptions.unshift({
                        name: this.translateService.getString('1 min.'),
                        value: 1,
                    });
                    this.uptimePingTimeRequestOptions.unshift({
                        name: this.translateService.getString('1 min.'),
                        value: 1,
                    });
                }
            }
        } else {
            if (this.uptimeAnswerTimeRequestOptions[0].value === 1 && this.uptimePingTimeRequestOptions[0].value === 1) {
                this.uptimeAnswerTimeRequestOptions.shift();
                this.uptimePingTimeRequestOptions.shift();
            }
        }
    }
}
